import { themeOverride } from '@/theme/theme'

export const CHART_COLORS = [
  themeOverride.other?.colors.darkGreen,
  themeOverride.other?.colors.green,
  themeOverride.other?.colors.primaryDarkGreen,
  themeOverride.other?.colors.blue,
  themeOverride.other?.colors.blueDark,
  themeOverride.other?.colors.mediumPurple,
  themeOverride.other?.colors.purple,
  themeOverride.other?.colors.purpleDark,
  themeOverride.other?.colors.purpleTint,
]
